import React from "react";
import {withTranslation} from "react-i18next";
import SessioneUtente from "../../sessionManager/SessioneUtente";
import SegnalazioniServices from "../../services/SegnalazioniServices";
import StatoInvioPremalServices from "../../services/StatoInvioPremalServices";
import styles from "./InserimentoSegnalazioni.module.css";
import Table from "../../components/table/Table";
import Utils from "../../utils/Utils";
import OggettiUtili from "../../utils/OggettiUtili.json";
import Icon from "../../components/icon/Icon"
import Ruoli from "../../utils/Ruoli.json"
import Modale from "../../components/modale/Modale";
import Spinner from "../../components/spinner/Spinner";
import ToasterSingleton from "../../singleton/ToasterSingleton";
import history from "../../utils/History";
import {states} from '../Wizard/States/States';
class TabelleMonitoraggio extends React.Component {

    state = {
        rows: [],
        rowsNonFiltrate: [],
        totalElements: 0,
        page: 0,
        totalPages: 0,
        size: this.props.pageSize? this.props.pageSize : 10,
        loading: false,
        sendRequest: false,
        oldParams: {},
        malattieCodice: JSON.parse(sessionStorage.getItem("malattiePerCodice"))
    }

    constructor(props) {
        super(props);
        this.changePageTable = this.changePageTable.bind(this)
        this.changePaginationTable = this.changePaginationTable.bind(this);
        this.setStateGenerico = this.setStateGenerico.bind(this)
        this.buildParams = this.buildParams.bind(this)
        this.sendRequest = this.sendRequest.bind(this)
        this.downloadXls = this.downloadXls.bind(this)
        this.downloadPdf = this.downloadPdf.bind(this)
        this.onClickButtonsTabella = this.onClickButtonsTabella.bind(this)
        this.filtraRighe = this.filtraRighe.bind(this)
    }

    componentDidMount() {

        ToasterSingleton.instance().sottoscrizione(this)

        let stato = sessionStorage.getItem("filtriMonitoraggio")? JSON.parse(sessionStorage.getItem("filtriMonitoraggio")) : null
        if (stato) {
            let object = {
                stato: stato,
                setStatePadre: this.setStateGenerico,
                rows: this.props.rowFiltri,
                applicaFiltri: (filtri) => {
                    this.sendRequest(this.buildParams(filtri, true, 0))
                }
            }
            this.props.sendFiltri(object)
            this.sendRequest(this.buildParams(stato, true, 0))
        } else {
            let object = {
                stato: this.props.filtri,
                setStatePadre: this.setStateGenerico,
                rows: this.props.rowFiltri,
                applicaFiltri: () => {
                    this.sendRequest(this.buildParams(this.props.filtri, true, 0))
                }
            }
            this.props.sendFiltri(object)
            this.sendRequest(this.buildParams())
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.statoInvio !== this.props.statoInvio) {
            let stato = sessionStorage.getItem("filtriMonitoraggio")? JSON.parse(sessionStorage.getItem("filtriMonitoraggio")) : null
            if (stato) {
                let object = {
                    stato: stato,
                    setStatePadre: this.setStateGenerico,
                    rows: this.props.rowFiltri,
                    azzeraCheckbox: this.props.azzeraCheckbox,
                    applicaFiltri: (stato) => {
                        this.sendRequest(this.buildParams(stato, true, 0))
                    }
                }
                this.props.sendFiltri(object)
                this.filtraRighe()
            } else {
                let object = {
                    stato: this.props.filtri,
                    setStatePadre: this.setStateGenerico,
                    rows: this.props.rowFiltri,
                    azzeraCheckbox: this.props.azzeraCheckbox,
                    applicaFiltri: () => {
                        this.sendRequest(this.buildParams(this.props.filtri, true, 0))
                    }
                }
                this.props.sendFiltri(object)
                this.filtraRighe()
            }
        }
    }

    filtraRighe() {
        this.setState({loading: true});
        const filteredRows = this.state.rowsNonFiltrate.filter(row =>
            this.props.statoInvio.includes(row.statoInvio)
        );
        this.setState({ rows: filteredRows, loading: false });
    }

    setStateGenerico(object) {
        this.setState(object)
    }

    changePageTable(sort, direction, page, size) {
        if (this.props.azzeraCheckbox) {
            this.props.azzeraCheckbox()
        }

        let params = this.buildParams(this.props.filtri ? this.props.filtri : null, this.state.sendRequest);

        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size
            } else {
                params.size = size
            }
        }

        params.page = page;

        if (sort !== null) {
            if (sort === "paziente")
                sort = "cognome"
            params.sort = sort
        }

        if (direction !== null) {
            params.order = direction
        }

        this.sendRequest(params);
    }

    changePaginationTable(sort, direction, page, size) {
        let params = this.buildParams(this.props.filtri ? this.props.filtri : null, this.state.sendRequest);


        if (direction !== null) {
            params.order = direction
        }
        params.sort = sort
        params.page = page;
        params.size = size;

        this.sendRequest(params);

    }

    buildParams(andParams, sendRequest, page, size) {
        let params = {
            ulss: SessioneUtente.getInstance().ruoliUtente.includes(Ruoli.Operatore_Sisp.descrizione)
                || SessioneUtente.getInstance().ruoliUtente.includes(Ruoli.Operatore_Sisp_HIV.descrizione)
                ? SessioneUtente.getInstance().ulss : null,
            invioSchedaSpeciale: this.props.invioSchedaSpeciale,
            page: page || page === 0 ? page : this.state.page,
            size: size ? size : this.state.size,
            malattia: this.props.ruolo === "r" ? Utils.mapMalattieDescrizione("Tubercolosi") : null,
            ruolo: this.props.ruolo ? this.props.ruolo : "",
            tbcpolmonare: this.props.tbcpolmonare ? this.props.tbcpolmonare : "",
            lis: this.props.filtri.lis ? this.props.filtri.lis : "",
            integrazioneLis: this.props.filtri.integrazioneLis ? this.props.filtri.integrazioneLis : "",
            segnalazioniDaLis: this.props.filtri.segnalazioniDaLis ? this.props.filtri.segnalazioniDaLis : ""
        };

       if (andParams && sendRequest) {
            let paramsFinale = JSON.parse(JSON.stringify(andParams))

            if (paramsFinale.malattia){
                paramsFinale.malattia = andParams.malattia.codice
                paramsFinale.descrizioneMalattia = andParams.malattia.descrizione
            }
            if (paramsFinale.dataDa)
                paramsFinale.dataDa = Utils.transformDateForBackend(andParams.dataDa)
            if (paramsFinale.dataA)
                paramsFinale.dataA = Utils.transformDateForBackend(andParams.dataA)
            if (paramsFinale.statoSchedaStandard)
                paramsFinale.statoSchedaStandard = andParams.statoSchedaStandard
            if (paramsFinale.ulssSegnalazione) {
                if (paramsFinale.ulssSegnalazione.codice) {
                    paramsFinale.ulssSegnalazione = andParams.ulssSegnalazione.codice
                } else {
                    paramsFinale.ulssSegnalazione = andParams.ulssSegnalazione
                }
            }
            if (this.props.invioSchedaSpeciale !== "1" && paramsFinale.statoSchedaSpeciale) {
                paramsFinale.statoSchedaSpeciale = andParams.statoSchedaSpeciale
            } else if (this.props.invioSchedaSpeciale === "1" && paramsFinale.statoSchedaSpeciale === "01") {
                paramsFinale.statoSchedaSpeciale = andParams.statoSchedaSpeciale
            } else {
                paramsFinale.statoSchedaSpeciale = ""
            }

           if (paramsFinale.gruppoStatoSegnalazione)
               paramsFinale.gruppoStatoSegnalazione = andParams.gruppoStatoSegnalazione

           if (paramsFinale.segnalazioniLIS)
               paramsFinale.segnalazioniLIS = andParams.segnalazioniLIS

           if (paramsFinale.utenteInserimento)
                paramsFinale.utenteInserimento = andParams.utenteInserimento

            if (paramsFinale.esitoTrattamento)
                paramsFinale.esitoTrattamento = andParams.esitoTrattamento

            if (paramsFinale.idSegnalazione)
                paramsFinale.idSegnalazione = andParams.idSegnalazione
            params = Object.assign(params, paramsFinale)
        } else {
            let parametriOld = JSON.parse(JSON.stringify(this.state.oldParams))
            params = Object.assign(params, parametriOld)

        }
        this.setState({sendRequest: sendRequest})
        let object = JSON.parse(JSON.stringify(params))
        return Utils.removeEmptyValueFromObject(object);
    }

    sendRequest(params) {

        if (params.sort && params.sort.includes('idSegnalazioneLabel')) {
            params.sort = params.sort.replace('idSegnalazioneLabel', 'idSegnalazione');
        }

        if (params.size)
            this.setState({loading: true, size: params.size});
        else
            this.setState({loading: true});

        if (!this.props.statoInvioPremal) {

            SegnalazioniServices.getMonitoraggio(params).then((data) => {
                let dataMonitoraggio = data.data.content;

                for (let key in dataMonitoraggio) {
                    const malattia = this.state.malattieCodice[dataMonitoraggio[key].malattia]
                    const firstDate = new Date(dataMonitoraggio[key].dataSegnalazione)
                    const secondDate = new Date(Utils.transformDateForBackend(Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp())))
                    dataMonitoraggio[key].Prosegui = "Prosegui"
                    if (dataMonitoraggio[key].statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Segnalazione.codice) {
                        dataMonitoraggio[key].Prosegui = "Prosegui" + dataMonitoraggio[key].idSegnalazione
                    }
                    dataMonitoraggio[key].statoInvioScheda = "00"
                    dataMonitoraggio[key].scadenza = dataMonitoraggio[key].scadenza === 1000000 ? "VALIDATA" : dataMonitoraggio[key].scadenza === 1000001 ? "SCADUTA" : dataMonitoraggio[key].scadenza !== 1000002 ? dataMonitoraggio[key].scadenza : ""
                    if (this.props.invioSchedaSpeciale && this.props.invioSchedaSpeciale === "1") {
                        dataMonitoraggio[key].statoSchedaSpeciale = "00"
                        dataMonitoraggio[key].Prosegui = ""
                    }

                }

                if (!dataMonitoraggio || dataMonitoraggio.length == 0) {
                    this.aggiungiToaster();
                }
                this.setState({
                    rows: dataMonitoraggio,
                    totalElements: data.data.totalElements,
                    totalPages: data.data.totalPages, page: params.page,
                    loading: false,
                    oldParams: params
                })
            }).catch(() => {
                this.setState({rows: [], totalElements: 0, loading: false});
            })
        } else {
            StatoInvioPremalServices.getFlussiSegnalazioni(params).then((data) => {
                let dataFlussi = data.data.content;

                if (!dataFlussi || dataFlussi.length === 0) {
                    this.aggiungiToaster();
                }
                else {
                    for (let key in dataFlussi) {
                        dataFlussi[key].timestampCompilazione = Utils.transformTimeStampForFrontend(dataFlussi[key].timestampCompilazione)
                        dataFlussi[key].cancellazioneDatabase = <span onClick={()=>this.onClickButtonsTabellaElimina(dataFlussi[key].id)}><Icon style={{fill: "red", cursor: "pointer"}} id={"it-delete"} classes={"icon-sm"}></Icon></span>
                        if(!dataFlussi[key].idUpload || dataFlussi[key].idUpload === null || dataFlussi[key].idUpload === "") {
                            dataFlussi[key].idUpload = <Icon style={{fill: "#000000"}} id={"it-minus"} classes={"icon-sm"}></Icon>
                        }
                        if (dataFlussi[key].statoInvio === "MX22" || dataFlussi[key].statoInvio === "22") {
                            dataFlussi[key].fileScarti = <span onClick={()=>this.onClickButtonsTabella(dataFlussi[key].idUpload)}><Icon style={{fill: "#1b7ea9", cursor: "pointer"}} id={"it-download"} classes={"icon-sm"}></Icon></span>

                        }
                        else {
                            if (dataFlussi[key].statoInvio === null || dataFlussi[key].statoInvio === "") {
                                dataFlussi[key].statoInvio = "ND00"
                            }
                            dataFlussi[key].fileScarti = <Icon style={{fill: "#000000"}} id={"it-minus"} classes={"icon-sm"}></Icon>

                        }
                        dataFlussi[key].idSegnalazione = dataFlussi[key].idSegnalazioneString
                    }
                }
                this.props.azzeraCheckbox()
                this.setState({
                    rows: dataFlussi,
                    rowsNonFiltrate: dataFlussi,
                    totalElements: data.data.totalElements,
                    totalPages: data.data.totalPages, page: params.page,
                    loading: false,
                    oldParams: params
                })
            }).catch(() => {
                this.setState({rows: [], totalElements: 0, loading: false});
            })
        }

    }

    onClickButtonsTabella(idUpload){
        this.setState({loading: true})
        StatoInvioPremalServices.getFileScarto(idUpload)
            .then((res) => {
                if (res.status === 200) {
                    let nome = res.data.nomeFile.split(".")
                    Utils.downloadReport(res.data.fileScarti, nome[0], "zip")
                }
                this.setState({loading: false})
            })
            .catch(() => {
                this.setState({loading: false})
            });


    }

    onClickButtonsTabellaElimina(id){
        this.setState({loading: true})
        StatoInvioPremalServices.deleteRecord(id)
            .then((res) => {
                if (res.status === 200) {
                    let params = this.buildParams()
                    StatoInvioPremalServices.getFlussiSegnalazioni(params).then((data) => {
                        let dataFlussi = data.data.content;

                        if (!dataFlussi || dataFlussi.length == 0) {
                            this.aggiungiToaster();
                        }
                        else {
                            for (let key in dataFlussi) {
                                dataFlussi[key].timestampCompilazione = Utils.transformTimeStampForFrontend(dataFlussi[key].timestampCompilazione)
                                dataFlussi[key].cancellazioneDatabase = <span onClick={()=>this.onClickButtonsTabellaElimina(dataFlussi[key].id)}><Icon style={{fill: "red", cursor: "pointer"}} id={"it-delete"} classes={"icon-sm"}></Icon></span>
                                if(!dataFlussi[key].idUpload || dataFlussi[key].idUpload === null || dataFlussi[key].idUpload === "") {
                                    dataFlussi[key].idUpload = <Icon style={{fill: "#000000"}} id={"it-minus"} classes={"icon-sm"}></Icon>
                                }
                                if (dataFlussi[key].statoInvio === "MX22" || dataFlussi[key].statoInvio === "22") {
                                    dataFlussi[key].fileScarti = <span onClick={()=>this.onClickButtonsTabella(dataFlussi[key].idUpload)}><Icon style={{fill: "#1b7ea9", cursor: "pointer"}} id={"it-download"} classes={"icon-sm"}></Icon></span>

                                }
                                else {
                                    if (dataFlussi[key].statoInvio === null || dataFlussi[key].statoInvio === "") {
                                        dataFlussi[key].statoInvio = "ND00"
                                    }
                                    dataFlussi[key].fileScarti = <Icon style={{fill: "#000000"}} id={"it-minus"} classes={"icon-sm"}></Icon>

                                }
                                dataFlussi[key].idSegnalazione = dataFlussi[key].idSegnalazioneString
                            }
                        }
                        this.setState({
                            rows: dataFlussi,
                            totalElements: data.data.totalElements,
                            totalPages: data.data.totalPages, page: params.page,
                            loading: false,
                            oldParams: params
                        })
                    }).catch(() => {
                        this.setState({rows: [], totalElements: 0, loading: false});
                    })
                }
                this.setState({loading: false})
            })
            .catch(() => {
                this.setState({loading: false})
            });


    }


    downloadXls() {
        this.setState({loading: true});
        let tipoMonitoraggio = this.props.invioSchedaSpeciale === "1" ? "invioSchedeSpeciali":this.props.inserimentoSegnalazioni === "1" || this.props.inserimentoSegnalazioni2 === "1"? "inserimentoSegnalazioni" : "schedaSpecialeTBC"
        SegnalazioniServices.getMonitoraggioExcelPdf(this.buildParams(this.props.filtri,this.state.sendRequest), "formato=xlsx","tipoMonitoraggio="+tipoMonitoraggio).then(data => {
            Utils.downloadReport(data.data.stream, data.data.descrizione, data.data.formato)
            this.setState({loading: false});
        })
    }


    downloadPdf() {
        this.setState({loading: true});
        let tipoMonitoraggio = this.props.invioSchedaSpeciale === "1" ? "invioSchedeSpeciali":this.props.inserimentoSegnalazioni === "1" || this.props.inserimentoSegnalazioni2 === "1"? "inserimentoSegnalazioni" : "schedaSpecialeTBC"
        SegnalazioniServices.getMonitoraggioExcelPdf(this.buildParams(this.props.filtri,this.state.sendRequest), "formato=pdf","tipoMonitoraggio="+tipoMonitoraggio).then(data => {
            Utils.downloadReport(data.data.stream, data.data.descrizione, data.data.formato)
            this.setState({loading: false});
        })
    }

    onCellClick = (col, row) => {
        if (col.tipo === "link" && col.label === "Prosegui") {
            // chiama la funzione passata dal padre
            if (this.props.inserimentoSegnalazioni) {
            this.props.inserimentoSegnalazioni(row);
            }
        }
        };


    render() {

        const {t} = this.props;


        // --- dentro render() di TabelleMonitoraggio ---
        const mappedRows = (this.state.rows || []).map(row => {
            const raw = row && (row.idSegnalazione ?? row.idSegnalazioneString ?? "");
            const normalized = String(raw)
                .replace(/\u00A0/g, " ")
                .trim()
                .replace(/\s+/g, " ")
                .toLowerCase();

            const isNullNull = normalized === "null null" || normalized === "null";

            // 👇 Se è null/null, mostro un link cliccabile
            const display = isNullNull
                ? (
                    <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault(); // evita ricarica pagina
                        if (this.props.inserimentoSegnalazioni) {
                        this.props.inserimentoSegnalazioni(row);
                        }
                    }}
                    className={styles.linkSegnalazione}
                    >
                        Prendere in carico
                    </a>
                )
                : (row.idSegnalazione ?? row.idSegnalazioneString ?? "");

            // --- normalizzazione dataSegnalazione ---
            let dataSegnalazione = row.dataSegnalazione;
            if (dataSegnalazione) {
                try {
                const d = new Date(dataSegnalazione);
                if (!isNaN(d.getTime())) {
                    dataSegnalazione = d.toISOString().slice(0, 10);
                }
                } catch (e) {
                console.warn("Formato data non valido:", row.dataSegnalazione);
                }
            }

            return {
                ...row,
                idSegnalazioneLabel: display,
                utenteInserimento: row.idSegnalazione!=='null null' ? row.utenteInserimento : "LIS",
                scadenza:row.idSegnalazione!=='null null' ? row.scadenza : '',
                statoSegnalazione: row.idSegnalazione!=='null null' ? row.statoSegnalazione : "04",
                dataSegnalazione,
            };
        });


        // Modifico *solo per la visualizzazione* la colonna che punta a idSegnalazione:
        // cambio key -> idSegnalazioneLabel così la table userà il label per mostrare, ma
        // nomeParametro rimane "idSegnalazione" così il link usa il valore reale.
        const modifiedCols = (this.props.cols || []).map(col => {
            if (col.key === "idSegnalazione") {
                return {
                    ...col,
                    key: "idSegnalazioneLabel" // usa il campo di display
                    // nomeParametro rimane invariato -> link userà row['idSegnalazione']
                };
            }
            return col;
        });

        const sezione1 = (
            <div className={styles.contenitoreTabella}>
                <Table
                    cols={modifiedCols}
                    rows={mappedRows}
                    title={t(this.props.title)}
                    empty={this.state.rows && this.state.rows.length === 0}
                    emptyMsg={t("Tables.Home.noSegnalazioni")}
                    lengthEditable={this.props.lengthEditable}
                    homePage={this.props.homePage}
                    totalElements={this.state.totalElements}
                    totalPages={this.state.totalPages}
                    page={this.state.page}
                    changePage={this.changePageTable}
                    changePagination={this.changePaginationTable}
                    information={this.props.information}
                    tableLenght={this.props.pageSize}
                    onCellClick={this.onCellClick}
                    inserimentoSegnalazioni={this.props.inserimentoSegnalazioni}
                />
            </div>
        );


        return (
            <div className={"container"}>
                {ToasterSingleton.instance().renderToaster()}
                {this.state.loading ?
                    (<div><Spinner/></div>) : (<div/>)}
                {this.props.ruolo  && !this.props.statoInvioPremal ?
                    <div>
                        <Modale className={styles.testo}
                                id="modaleDownloadExcel"
                                name="modaleDownloadExcel"
                                modalText={this.state.totalElements > 5000 ? "Si vuole procedere con il download di " + this.state.totalElements + " segnalazioni? L’operazione potrebbe richiedere fino ad un minuto. Si consiglia di applicare uno o più filtri per diminuire il tempo di elaborazione." : "Si vuole procedere con il download di " + this.state.totalElements + " segnalazioni? "}
                                text={<Icon style={{paddingRight: "10px", fill: "#00d700"}} id="it-file"/>}
                                typeModal="modalConsenso"
                                textButtonOk={"Prosegui"}
                                textButtonKo={"Annulla"}
                                classes="btn mt-2 btnWhite mb-1 "
                                style={{
                                    padding: "5px",
                                    border: "none",
                                    background: "none",
                                    float: "right",
                                    width: "30px"
                                }}
                                title={"Scarica in formato Excel"}
                                confirmFun={this.downloadXls}/>
                        <Modale title={"Scarica in formato Pdf"}
                                className={styles.testo}
                                id="modaleDownload"
                                name="modaleDownload"
                                modalText={this.state.totalElements > 5000 ? "Si vuole procedere con il download di " + this.state.totalElements + " segnalazioni? L’operazione potrebbe richiedere fino ad un minuto. Si consiglia di applicare uno o più filtri per diminuire il tempo di elaborazione." : "Si vuole procedere con il download di " + this.state.totalElements + " segnalazioni? "}
                                text={<Icon style={{paddingRight: "10px", fill: "#ff0000"}} id="it-file"/>}
                                typeModal="modalConsenso"
                                textButtonOk={"Prosegui"}
                                textButtonKo={"Annulla"}
                                classes="btn mt-2 btnWhite mb-1 "
                                style={{
                                    padding: "5px",
                                    border: "none",
                                    background: "none",
                                    float: "right",
                                    width: "30px"
                                }}
                                confirmFun={this.downloadPdf}/>
                    </div> : <div></div>}
                <div className={styles.contenitore}>
                    {sezione1}
                </div>
            </div>
        )
    }


}

export default withTranslation('common')(TabelleMonitoraggio)
